export default __webpack_public_path__ + "008a32c0156aeff1e317cc830491f415.png";